// import { isNull } from "lodash";
import React, { /*useCallback,*/ useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
import { Map as GoogleMap, useMap } from "@vis.gl/react-google-maps";

// Imported assets
import usData from "../../../../../assets/data/2023_us_state_500K.json";

const mapStyle = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  clickableIcons: false,
  // colorScheme: "DARK",
  fullscreenControl: false,
  mapTypeControl: false,
  maxZoom: 22,
  minZoom: 0,
  streetViewControl: false,
  styles: [
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      stylers: [{ visibility: "off" }],
    },
  ],
  zoomControl: false,
};

const Map = ({ selectedPreview }) => {
  const map = useMap();
  // const appLocation = useLocation();
  // const navigate = useNavigate();

  // const [mapCenter, setMapCenter] = useState(null);
  // const [mapZoom, setMapZoom] = useState(null);

  const [mapOverlay, setMapOverlay] = useState(null);
    
  const removeMapOverlay = () => {
    if (mapOverlay) {
      mapOverlay.setMap(null);
      setMapOverlay(null);
    }
  };

  useEffect(() => {
    removeMapOverlay();

    // Outer bounds to cover the world
    const outer = [
      new window.google.maps.LatLng(85, 180),
      new window.google.maps.LatLng(85, 90),
      new window.google.maps.LatLng(85, 0),
      new window.google.maps.LatLng(85, -90),
      new window.google.maps.LatLng(85, -180),
      new window.google.maps.LatLng(0, -180),
      new window.google.maps.LatLng(-85, -180),
      new window.google.maps.LatLng(-85, -90),
      new window.google.maps.LatLng(-85, 0),
      new window.google.maps.LatLng(-85, 90),
      new window.google.maps.LatLng(-85, 180),
      new window.google.maps.LatLng(0, 180),
      new window.google.maps.LatLng(85, 180),
    ];

    let bounds = new window.google.maps.LatLngBounds();;

    switch (selectedPreview) {
      case "California": {
        // Inner bounds to cut out designated area from outer bounds
        let innerBoundaries = [];
        usData.features.forEach((feature) => {
          if (feature.attributes.NAME === "California") {
            let arr = feature.geometry.rings;
            arr.forEach((coords) => {
              let newBoundary = coords.map((latLng) => {
                return new window.google.maps.LatLng(latLng[1], latLng[0]);
              });
              innerBoundaries.push(newBoundary);
            });
          }
        });

        const innerPolygon = new window.google.maps.Polygon({
          paths: [...innerBoundaries],
          // map: map,
          // strokeColor: "#08609B",
          // strokeOpacity: 0,
          // strokeWeight: 0,
          // fillColor: "#08609B",
          // fillOpacity: 0,
        });
    
        const polygon = new window.google.maps.Polygon({
          paths: [outer, ...innerBoundaries],
          map: map,
          strokeColor: "#08609B",
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: "#08609B",
          fillOpacity: 1,
        });
    
        setMapOverlay(polygon);

        // Get bounds for map based on inner polygon object
        let paths = innerPolygon.getPaths();
        let path;
        for (let i = 0; i < paths.getLength(); i++) {
          path = paths.getAt(i);
          for (let j = 0; j < path.getLength(); j++) {
            bounds.extend(path.getAt(j));
          }
        }
    
        break;
      }

      case "Continental United States": {
        // Inner bounds to cut out designated area from outer bounds
        let innerBoundaries = [];
        usData.features.forEach((feature) => {
          if (
            !(
              feature.attributes.NAME === "Hawaii" ||
              feature.attributes.NAME === "Alaska" ||
              feature.attributes.NAME === "Puerto Rico" ||
              feature.attributes.NAME === "American Samoa" ||
              feature.attributes.NAME === "Guam" ||
              feature.attributes.NAME === "United States Virgin Islands" ||
              feature.attributes.NAME ===
                "Commonwealth of the Northern Mariana Islands"
            )
          ) {
            let arr = feature.geometry.rings;
            arr.forEach((coords) => {
              let newBoundary = coords.map((latLng) => {
                return new window.google.maps.LatLng(latLng[1], latLng[0]);
              });
              innerBoundaries.push(newBoundary);
            });
          }
        });
    
        const innerPolygon = new window.google.maps.Polygon({
          paths: [...innerBoundaries],
          // map: map,
          // strokeColor: "#08609B",
          // strokeOpacity: 0,
          // strokeWeight: 0,
          // fillColor: "#08609B",
          // fillOpacity: 0,
        });
    
        const polygon = new window.google.maps.Polygon({
          paths: [outer, ...innerBoundaries],
          map: map,
          strokeColor: "#08609B",
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: "#08609B",
          fillOpacity: 1,
        });
    
        setMapOverlay(polygon);
    
        // Get bounds for map based on inner polygon object
        let paths = innerPolygon.getPaths();
        let path;
        for (let i = 0; i < paths.getLength(); i++) {
          path = paths.getAt(i);
          for (let j = 0; j < path.getLength(); j++) {
            bounds.extend(path.getAt(j));
          }
        }
        
        break;
      }

      default: {
        break;
      }
    }

    map?.fitBounds(bounds, 20);
  }, [map, selectedPreview]);

  // const handleCameraChange = useCallback((e) => {
  //   setMapCenter(e.detail.center);
  //   setMapZoom(e.detail.zoom);
  // });

  return (
    <>
      <GoogleMap
        {...mapOptions}
        // center={!isNull(mapCenter) ? mapCenter : null}
        className={"admin-settings-map"}
        disableDefaultUI={true}
        gestureHandling={"none"}
        // mapId={"704f78d978e3652a"}
        mapTypeId={"hybrid"}
        // onCameraChanged={handleCameraChange}
        reuseMaps={false}
        style={mapStyle}
        // zoom={!isNull(mapZoom) ? mapZoom : null}
      >
        {/* {markers &&
          Object.values(markers).map((marker) => {
            return (
              <Marker
                data={marker}
                key={`marker-${marker.id}`}
                position={{
                  lat: Number(marker.lat),
                  lng: Number(marker.lon),
                }}
              />
            );
          })} */}
      </GoogleMap>
    </>
  );
};

export default Map;
